module.exports = __webpack_public_path__ + "static/media/cloud.55c03228.svg";